(function () {

    "use strict";

    function headListFilterController() {
        var vm = this;
        
        vm.filterArray = [
            {
                "typeOrAndSelected": "And",
                "leftOperator": {
                    "id": "application",
                    "name": "Aplicaci�n",
                    "idType": 1,
                    "isProperty": false,
                    "isContent": false
                },
                "rightOperator": "",
                "type": 6
            },
            {
                "typeOrAndSelected": "And",
                "leftOperator": {
                    "id": "Estado",
                    "name": "Estado",
                    "idType": 1,
                    "isProperty": false,
                    "isContent": false
                },
                "rightOperator": "",
                "type": 6
            }
        ];

        vm.filterMetoh = function () {
            var filter = [];
            vm.filterArray.forEach(function (item) { if (item.rightOperator) { filter.push(item); } });
            vm.service.getItemsPaged(filter);
        };

        vm.clearFilter = function () {
            vm.filterArray.forEach(function (item) { if (item.rightOperator) { item.rightOperator = ""; } });
        };

        vm.aditionalLabels = ["Estado"];

    }

    headListFilterController.$inject = [];

    angular.module("sphforms.main")
        .component("sphFormsHeadListFilter", {
            controller: headListFilterController,
            bindings: {
                iconapplyFilter: "=",
                service: "="
            },
            templateUrl: "modules/main/components/ui/basicList/headListFilter/headListFilter.template.html"
        });

}());